import React from 'react';
import BilanIconButton from './BilanIconButton';

interface ZipFileButtonProps {
  onClick?: (
    ev:
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
      | React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
}

export default function ZipFileButton({ onClick }: ZipFileButtonProps) {
  return (
    <BilanIconButton
      aria-label="Télécharger le bilan ZIP"
      iconType="attach"
      onClick={onClick}
      size="xs"
      variantType="primary"
    />
  );
}
